import { useEffect, useState } from 'react';
import { fetchDashboardStats } from '@/services/vastaanottoService';
import dayjs from 'dayjs';

export const useDashboardStats = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchDashboardStats(dayjs().toISOString());
        if (!cancelled) setData(res);
      }
      catch (e) {
        if (!cancelled) setError(e);
      }
      finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
};
